import { render, staticRenderFns } from "./repair-detail.vue?vue&type=template&id=496c2ec3&scoped=true&"
import script from "./repair-detail.vue?vue&type=script&lang=js&"
export * from "./repair-detail.vue?vue&type=script&lang=js&"
import style0 from "./repair-detail.vue?vue&type=style&index=0&id=496c2ec3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c2ec3",
  null
  
)

export default component.exports